import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { CareersPlan } from 'app/main/careers/models/career';

@Component({
  standalone: false,
  selector: 'app-payment-instruction',
  templateUrl: './payment-instruction.component.html',
  styleUrls: ['./payment-instruction.component.scss']
})
export class PaymentInstructionComponent implements OnInit {

  @Input() coreConfig:any;
  @Input() paymentInfo: any = {};
  @Input() careersPlan: CareersPlan;

  @Output() addSubscriptionEvt:EventEmitter<any> = new EventEmitter<any>();
  @Output() loadHomepageEvt:EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  ngOnInit(): void {
  }

  addSubscription(){
    this.addSubscriptionEvt.emit()
  }

  loadHomepage(){
    this.loadHomepageEvt.emit()
  }

}
